import { GeneralKeys as e } from "../../../i18n/translations/types/general.js";
import { Namespace as p } from "../../../i18n/translations/types/namespaces.js";
import { Button as c } from "../../ui/Button/Button.js";
import { useAdminApi as v } from "../../providers/AdminApiProvider/AdminApiProvider.js";
import { useAdminStore as t } from "../../../store/adminStore.js";
import { DialogTypes as u } from "../../ui/Dialog/Dialog.types.js";
import { Dialog as S } from "../../ui/Dialog/Dialog.js";
import { useCallback as g, useState as y } from "react";
import { jsx as l } from "react/jsx-runtime";
import { useTranslation as I } from "react-i18next";
var h = ({ dataTestid: r = "admin-session-invalid-dialog" }) => {
  const { t: i } = I(p.General), { server: s } = v(), d = t((o) => o.user.sessionInvalid), n = t((o) => o.setSessionInvalid), [m, a] = y(!1), f = g(async () => {
    a(!0);
    try {
      await s.refreshSelf(), n(!1);
    } catch {
      window.location.reload();
    } finally {
      a(!1);
    }
  }, [s, n]);
  return /* @__PURE__ */ l(S, {
    dataTestid: r,
    id: "adminSessionInvalid",
    open: d,
    onlyClosableViaButtons: !0,
    type: u.info,
    title: i(e.Notifications_SessionInvalidText),
    hideTitle: !0,
    showCloseButton: !1,
    description: i(e.Notifications_SessionInvalidText),
    footer: /* @__PURE__ */ l(c, {
      name: "session-invalid-reload",
      variant: "modal-primary",
      loading: m,
      onClick: f,
      children: i(e.ReloadPage)
    })
  });
};
h.displayName = "AdminSessionInvalidDialog";
export {
  h as AdminSessionInvalidDialog
};

//# sourceMappingURL=AdminSessionInvalidDialog.js.map